import { render } from "./PracticeOrder.vue?vue&type=template&id=6eefa760&scoped=true"
import script from "./PracticeOrder.vue?vue&type=script&lang=js"
export * from "./PracticeOrder.vue?vue&type=script&lang=js"

import "./PracticeOrder.vue?vue&type=style&index=0&id=6eefa760&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eefa760"]])

export default __exports__